export const ftReplaceState = (sett, params, url) => {
  if (typeof window.history != 'undefined' && typeof window.history.replaceState === 'function') {
    try {
      window.history.replaceState(sett, params, url)
    } catch (err) {
      console.error(err)
    }
  }
}
